import React from "react";
import Hero from "../Hero/Hero";
import Services from "../Services/Services";
import Crypto from "../Crypto/Crypto";
import VirtualCards from "../VirtualCards/VirtualCards";
import Features from "../Features/Features";
import Partners from "../Partners/Partners";
import Application from "../Application/Application";
import Startups from "../Startups/Startups";
import Testimonial from "../Testimonial/Testimonial";
import Newsletter from "../Newsletter/Newsletter";

const Home = () => {
  return (
    <div>
      <Hero />
      <Services />
      <Crypto />
      <VirtualCards />
      <Features />
      <Partners />
      <Application />
      <Startups />
      <Testimonial />
      <Newsletter />
    </div>
  );
};

export default Home;
